import { useCallback, useMemo } from "react"
import { useLocalStorage } from "react-use"

import { ViewerBackgroundType, ViewerFontSize, ViewerFontType } from "types"

/**
 * ローカルストレージからビューワー表示用の設定（フォント、背景など）を取得するhooks
 */
export const useDisplaySettings = (isAndroid?: boolean) => {
  const [backgroundType, setBackgroundType] =
    useLocalStorage<ViewerBackgroundType>(
      "viewer_backgroundType",
      ViewerBackgroundType.Cream,
    )

  const [fontType, setFontType] = useLocalStorage<ViewerFontType>(
    "viewer_fontType",
    isAndroid ? ViewerFontType.Gothic : ViewerFontType.Mincho, // Android はデフォルトはゴシック
  )

  const [fontSize, setFontSize] = useLocalStorage<ViewerFontSize>(
    "viewer_fontSize",
    ViewerFontSize.Medium,
  )

  const fontSizeNum = useMemo(() => {
    switch (fontSize) {
      case "small":
        return 16

      case "medium":
        return 18

      case "large":
        return 20

      default:
        return 18
    }
  }, [fontSize])

  const handleChangeBackgroundType = useCallback(
    (backgroundType: ViewerBackgroundType) => {
      setBackgroundType(backgroundType)
    },
    [setBackgroundType],
  )

  const handleChangeFontType = useCallback(
    (fontType: ViewerFontType) => {
      setFontType(fontType)
    },
    [setFontType],
  )

  const handleChangeFontSize = useCallback(
    (fontSize: ViewerFontSize) => {
      setFontSize(fontSize)
    },
    [setFontSize],
  )

  const isDarkMode = useMemo(() => {
    return backgroundType === "black"
  }, [backgroundType])

  return {
    backgroundType,
    fontType,
    fontSize,
    fontSizeNum,
    isDarkMode,
    handleChangeBackgroundType,
    handleChangeFontType,
    handleChangeFontSize,
  }
}
